import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ServiceProviderService } from '../../Service/Service-providers/service-provider.service';

@Component({
  selector: 'app-mark-disable',
  templateUrl: './mark-disable.component.html',
  styleUrl: './mark-disable.component.scss'
})
export class MarkDisableComponent {

 @Input() distributorName!: string;
  @Input() address!: string;
  @Input() totalSpCount!: number;
  @Input() totalCustomerCount!: number;
  @Input() distributors: any[] = [];
  @Input() distributorId!: number;

  @Output() closeModal = new EventEmitter<void>();
  @Output() refreshList = new EventEmitter<void>();

  selectedDistributor: any;

   constructor(
    private api: ServiceProviderService,
    
  ) { }
  onCancel() {
    console.log('Cancel clicked');
    this.closeModal.emit();
  }

  submit() {
    console.log('Submitting disable for:', this.distributorId, 'with assign to:', this.selectedDistributor?.distributorId);

  if (!this.selectedDistributor?.distributorId) {
    console.warn('No distributor selected');
    return;
  }

  this.api.disableDistributor(this.distributorId, this.selectedDistributor.distributorId).subscribe({
    next: () => {
      console.log('Distributor disabled successfully');
      this.refreshList.emit();
      this.closeModal.emit();
    },
    error: (err) => {
      console.error('Failed to disable distributor:', err);
      // Optionally show error notification
    }
  });
}

  
  getAvatarText(name: string): string {
    return name ? name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : 'P';
  }
}
